import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerHelper } from '../../../../helpers/spinner.helper';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { ProjectAttendee } from '../../../../models/projects/project-attendee.model';
import { Project } from '../../../../models/projects/project.model';
import { ProjectsService } from '../../../../services/projects/projects.service';

@Component({
    selector: 'dialog-list-pending-attendees',
    templateUrl: './dialog-list-pending-attendees.component.html',
    styleUrls: ['./dialog-list-pending-attendees.component.scss'],
})
export class DialogListPendingAttendeesComponent {
    @Input() public isMemberOrOwnerOfProject: boolean;
    @Input() public project: Project;
    public selectedAttendee = new ProjectAttendee();
    public selectedPendingAttendee = new ProjectAttendee();
    @Input() public visible: boolean;
    @Output() public visibleChange = new EventEmitter<boolean>();

    constructor(
        private readonly projectsService: ProjectsService,
        private readonly spinnerHelper: SpinnerHelper,
        private readonly toastrHelper: ToastrHelper,
        private readonly translate: TranslateService,
    ) {}

    public acceptAttendee(attendee: ProjectAttendee) {
        this.spinnerHelper.showSpinner();
        this.projectsService.acceptAttendee(this.project.id, attendee.id).subscribe(
            () => {
                const msg = this.translate.instant('projects.projectDetails.toast.acceptAttendee', {
                    attendeeName: `${attendee.firstName} ${attendee.lastName}`,
                });
                this.toastrHelper.showSuccess(msg);
                this.project.pendingAttendees = this.project.pendingAttendees.filter((pendingAttendee) => pendingAttendee.id !== attendee.id);
                this.project.attendees.push(attendee);
                if (this.project.pendingAttendees.length === 0) {
                    this.visibleChange.emit(false);
                }
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => {
                this.spinnerHelper.hideSpinner();
            },
        );
    }

    public closeWaitingAttendeesModal(slidePanel: any) {
        slidePanel.slideToCenter();
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public denyAttendee(attendee: ProjectAttendee) {
        this.spinnerHelper.showSpinner();
        this.projectsService.denyAttendee(this.project.id, attendee.id).subscribe(
            () => {
                const msg = this.translate.instant('projects.projectDetails.toast.denyAttendee', {
                    attendeeName: `${attendee.firstName} ${attendee.lastName}`,
                });
                this.toastrHelper.showSuccess(msg);
                this.project.pendingAttendees = this.project.pendingAttendees.filter((pendingAttendee) => pendingAttendee.id !== attendee.id);
                if (this.project.pendingAttendees.length === 0) {
                    this.visibleChange.emit(false);
                }
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => {
                this.spinnerHelper.hideSpinner();
            },
        );
    }

    public getLabel(firstName: string, lastName: string) {
        if (firstName?.length && lastName?.length) {
            return firstName.slice(0, 1) + lastName.slice(0, 1);
        }
        return '';
    }
}
